import { Button, Input, InputNumber, Select } from "antd"
import { DownOutlined } from "@ant-design/icons"
import styles from "@/styles/view-cart.module.scss"

interface DiscountPanelProps {
  applyBtnLoading: boolean
  coupon: any
  couponPackage: number
  credits: number
  creditsInput: any
  inputFocus: boolean
  isLogin: boolean
  packagesList: any[]
  points: number
  pointsInput: any
  showCoupon: boolean
  onApplyDiscount: () => void
  onCouponChange: (value: string) => void
  onCouponFocusChange: (focused: boolean) => void
  onCouponPackageChange: (couponPackageId: number, option: any) => void
  onCreditsInputChange: (value: any) => void
  onPointsInputChange: (value: any) => void
  onToggleCoupon: () => void
}

const normalizePositiveInteger = (val: any, setValue: (value: any) => void) => {
  if (val === null || val === undefined) {
    setValue(0)
  } else if (Number.isInteger(val) && val >= 0) {
    setValue(val)
  }
}

const DiscountPanel = ({
  applyBtnLoading,
  coupon,
  couponPackage,
  credits,
  creditsInput,
  inputFocus,
  isLogin,
  packagesList,
  points,
  pointsInput,
  showCoupon,
  onApplyDiscount,
  onCouponChange,
  onCouponFocusChange,
  onCouponPackageChange,
  onCreditsInputChange,
  onPointsInputChange,
  onToggleCoupon
}: DiscountPanelProps) => (
  <div className={styles['coupon-box']}>
    <div className={styles['coupon-box-head']}>
      <div className={styles['coupon-title']} onClick={onToggleCoupon} style={{ borderBottom: showCoupon ? "none" : '1px solid #c7c7c7' }}>
        Optional Discount and Coupon&nbsp;&nbsp;<DownOutlined />
      </div>
      {
        !!(!isLogin && showCoupon)
        &&
        <Button className={styles['signIn-btn']} href="/login?redirect=/view-cart" type="link">Sign In</Button>
      }
    </div>

    <div className={`${styles['collapsible']} ${showCoupon && styles['open']}`}>
      <div className={styles['coupon-area']}>
        <div className={styles['couponItem']}>
          <div className={styles['couponItem-label']}>
            <p>Total <span className={styles['num']}>{credits}</span> Credits<br />I want to use</p>
          </div>
          <InputNumber
            value={creditsInput}
            onChange={(val: any) => normalizePositiveInteger(val, onCreditsInputChange)}
            className={styles['couponItem-input']}
            placeholder={!isLogin ? 'please sign in to check your credits' : ''}
            style={{ width: "100%" }}
            controls={false}
            min={0}
            precision={0}
          />
        </div>

        <div className={styles['line']}></div>

        <div className={styles['couponItem']}>
          <div className={styles['couponItem-label']}>
            <p>Total <span className={styles['num']}>{points}</span> CrazyPoints<br />I want to use</p>
          </div>
          <InputNumber
            value={pointsInput}
            onChange={(val: any) => normalizePositiveInteger(val, onPointsInputChange)}
            className={styles['couponItem-input']}
            placeholder={!isLogin ? 'please sign in to check your points' : ''}
            style={{ width: "100%" }}
            controls={false}
            min={0}
            precision={0}
          />
        </div>

        <div className={styles['line']}></div>

        <div className={styles['couponItem']}>
          <div className={styles['couponItem-label']}>
            Apply Your Coupon:
          </div>
          <div className={styles['coupon-input-box']}>
            <Input
              className={styles['couponItem-input']}
              placeholder="coupon code"
              value={coupon}
              onChange={(event: any) => onCouponChange(event.target.value)}
              onFocus={() => onCouponFocusChange(true)}
              onBlur={() => {
                setTimeout(() => {
                  onCouponFocusChange(false)
                }, 150)
              }}
            />
            <Select
              value={couponPackage}
              className={styles['couponItem-select']}
              options={packagesList}
              onChange={onCouponPackageChange}
              open={inputFocus}
              fieldNames={{ label: 'name', value: 'id' }}
            />
          </div>
          <Button className={styles['apply-btn']} onClick={onApplyDiscount} loading={applyBtnLoading}>Apply Discount</Button>
        </div>
      </div>
    </div>
  </div>
)

export default DiscountPanel
